import { TablePaginationConfig } from "antd";
import { fleetModelsApi } from "api/fleetModel";
import { useDataLoadingContext } from "contexts/DataLoadingContext";
import { useNotificationContext } from "contexts/NotificationContext";
import { ITableData, defaultTableData } from "models";
import { IFleetModel } from "models/fleetModel";
import { ChangeEvent, useEffect, useState } from "react";

export default function useFleetModel() {
  const { showError } = useNotificationContext();
  const { reloadFleetModel } = useDataLoadingContext();
  const [data, setData] = useState<ITableData<IFleetModel>>(defaultTableData);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [data.page, data.search, reloadFleetModel]);

  const fetchData = async () => {
    setData((prev) => ({ ...prev, loading: true }));
    const { data: response, error } = await fleetModelsApi(
      data.page,
      data.per_page,
      data.search
    );
    if (response) {
      response.data = response.data.map((value) => ({
        ...value,
        key: value.id,
      }));
      setData((prev) => ({ ...prev, ...response }));
    } else showError(error!.message);
    setData((prev) => ({ ...prev, loading: false }));
  };

  const handlePageChange = ({ current }: TablePaginationConfig) => {
    if (current) setData((prev) => ({ ...prev, page: current }));
  };

  const handleSearch = ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => {
    setData((prev) => ({ ...prev, search: value ?? "" }));
  };

  return { data, handlePageChange, handleSearch };
}
